export default __webpack_public_path__ + "static/media/page3_6.38023b9c.png";